<template>
  <div class="agreement-content">
    <div>《大金服务小程序个人信息保护政策》</div>
    <div>（以下简称“本政策”）</div>
    <br />
    <div>更新及生效日期：2026年6月24日</div>
    <br />
    <div>
      <span>大金服务小程序（以下简称“本小程序”）是大金空调技术（中国）有限公司（以下简称为“我们”）为您提供的在线预约设备报修、移机、清洗、保养、视频客服等会员服务的小程序。在您使用本小程序的过程中，我们尊重并承诺保护您的个人信息安全，在开展业务时将会遵守与信息保密、数据保护和数据安全有关的法律规定。</span>
      <span class="blod-text">在您使用本小程序之前，请您务必仔细阅读、充分理解本政策，特别是应当重点阅读字体加粗的条款。只有在您确认充分理解并完全同意本政策的情况下，您可以完成登录程序成为本小程序的会员用户，并使用本小程序的服务。如果您不同意本政策的任何内容，您可以使用本小程序的点击、浏览、查看自助服务板块中的“收费标准”、“保修政策”、“服务标准”、“故障自查”、“遥控器说明”、“工程师认定”，但您将无法使用本小程序的其他会员服务。</span>
      <span>如果您有任何疑问、意见或建议，请通过本政策第八条约定的联系方式与我们联系。</span>
    </div>
    <br />
    <div>本个人信息保护政策将帮助您了解以下内容：</div>
    <div>一、我们收集的信息种类</div>
    <div>二、我们对您个人信息的使用</div>
    <div>三、我们对您个人信息的分享</div>
    <div>四、我们对未成年人的信息保护</div>
    <div>五、您对您个人信息的管理</div>
    <div>六、我们对个人信息保护政策的修改</div>
    <div>七、我们对您个人信息的保护措施</div>
    <div>八、联系我们</div>
    <div>九、其他</div>
    <br />
    <div>
      <div class="blod-text">一、我们收集的信息种类</div>
      <div>1. 信息的收集</div>
      <div>我们会在您自愿提供信息的情况下收集您的个人信息。</div>
      <br />
      <div class="blod-text">为了方便您使用本小程序的在线预约设备报修、移机、清洗、保养、视频客服等会员服务，在您首次登录本小程序时，您可以通过向我们提供您的手机号码并以该号码接收验证码进行登录，也可以直接授权我们获取您的微信昵称与头像进行登录，以便我们后续为您提供会员服务、保证账号安全。当您下单预约服务时，我们为履行订单义务、向您提供包括上门维修、移机、清洗、保养设备等服务，需要获取您的期望联系电话、期望联系人姓名、期望服务日期、服务地址（也即设备所在地址）、设备具体信息（包括产品分类、机型机号、故障图片、故障类型）、您自行填写的备注信息。您可以自由选择填写或者不填写真实的期望联系人姓名，我们仅将您填写的期望联系人姓名作为公司内部区分您身份的依据。请您确认提供的信息准确，如您填写的期望联系电话、期望上门时间、设备所在地址、设备具体信息有误，将可能导致我们未能与您取得联系、未能在期望时间提供服务、未能提供期望服务等结果。</div>
      <br />
      <div>为了方便您使用本小程序的服务，我们将请求您设备的下述权限，经授权后，方可使用相应服务：</div>
      <div class="blod-text">（1）安卓设备的获取权限：</div>
      <div class="blod-text">相机权限 ：调用目的为头像拍摄、机型扫码、工程师认证、服务单绑定、故障图拍摄，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">读取相册权限 ：调用目的为头像图片上传、扫码里的二维码图片读取，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">麦克风权限 ：调用目的为视频工程师，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">手机外呼 ：调用目的为调用手机功能拨打售后热线4008201081，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">（2）IOS设备的获取权限：</div>
      <div class="blod-text">相机权限 ：调用目的为头像拍摄、机型扫码、工程师认证、服务单绑定、故障图拍摄，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">读取相册权限 ：调用目的为头像图片上传、扫码里的二维码图片读取，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">麦克风权限 ：调用目的为视频工程师，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">手机外呼 ：调用目的为调用手机功能拨打售后热线4008201081，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">（3）鸿蒙设备的获取权限：</div>
      <div class="blod-text">相机权限 ：调用目的为头像拍摄、机型扫码、工程师认证、服务单绑定、故障图拍摄，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">读取相册权限 ：调用目的为头像图片上传、扫码里的二维码图片读取，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">麦克风权限 ：调用目的为视频工程师，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">手机外呼 ：调用目的为调用手机功能拨打售后热线4008201081，在调用前将向您询问是否同意开放权限</div>
      <div class="blod-text">（4）第三方插件信息/SDK信息：</div>
      <div class="blod-text">第三方公司名称（无），产品/服务（/），涉及个人信息（/），使用场景（/），使用目的（/），共享方式（/），第三方链接（/）</div>
      <br />
      <div class="blod-text">上述权限在获取时会取得您许可方才开启，如果您选择不开启，可能会导致调用权限的目的不能实现。您可以随时通过：点击小程序主页右上角“…”—点击“设置”—点击“获取信息”—点击“管理”来管理您授予本小程序的具体个人信息权限。请注意，单独的设备信息等记录是指无法识别特定主体的身份信息，当此类信息与其他信息结合可以确定特定主体的身份信息时，将被视为个人信息。除非得到您的许可，否则我们在使用此类信息时，将做匿名化、去标识化等脱敏处理。</div>
      <br />
      <div class="blod-text">Cookie和同类技术的服务：Cookie和同类设备信息标识技术是互联网中普遍使用的技术。当您使用我们的服务时，我们可能会使用相关技术向您的设备发送一个或多个 Cookie 或匿名标识符(以下简称“Cookie”)，以收集、标识和存储您访问、使用本小程序时的信息。我们承诺，仅在本政策所述目的范围内使用Cookie，不用于任何其他用途。具体而言，Cookie的使用旨在：</div>
      <div class="blod-text">(1) 保障服务的安全、高效运行；</div>
      <div class="blod-text">(2) 确认您账户的安全状态；</div>
      <div class="blod-text">(3) 排查系统崩溃、延迟等异常情况；</div>
      <div class="blod-text">(4) 简化您的操作，省去重复填写表单或输入搜索内容等步骤。</div>
      <br />
      <div>2. 信息的存储</div>
      <div>1）存储期限</div>
      <div>
        <span>为了确保您能持续享受我们的服务，我们将采取妥善的方式来保护您的个人信息安全，我们将按照您使用本小程序所委托的服务所必须且最短的期限内存储您的信息，当您使用本小程序所委托的服务事项全部完成，或注销、停止使用本小程序时，我们将根据相关法律的要求删除您的个人信息。</span>
        <span class="blod-text">如有涉及、关联服务和交易的信息，我们将自服务、交易完成之日起按照电子商务法规定的最短保存期限进行保留。</span>
      </div>
      <div>2）存储位置</div>
      <div>
        <span>我们非常重视您个人信息的存储安全，我们确保所有个人信息存储在中华人民共和国境内，以符合国家对数据存储地点的法律要求。</span>
        <span class="blod-text">除非取得您的单独同意，或为了履行与您订立的合同，或为了遵循法律法规规定的义务，我们不会向境外提供您的任何个人信息。</span>
      </div>
      <div>3）数据保护技术措施</div>
      <div>
        <span>我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们会使用加密技术提高个人信息的安全性，如提供HTTPS协议安全测览方式；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。</span>
      </div>
      <br />
    </div>
    <div>
      <div class="blod-text">二、我们对您个人信息的使用</div>
      <div>您提供的信息我们将用于为您提供服务和支持，包括：</div>
      <div>(1) 为您提供售后服务、维保服务及技术咨询等，包括上门以及后续进行情况跟进的目的而使用您的个人信息；</div>
      <div>(2) 就与本小程序项下的运营有显著影响的事项向用户发送通知；</div>
      <div>(3) 了解您对本公司关联企业服务的具体需求，了解服务的满意度，进行市场调查、促销等活动，以便于不断改进、完善各项服务；</div>
      <div>(4) 我们可能会收集您及其他用户的个人信息进行统计，以便于我们了解本小程序项下服务的使用情况及趋势，也有可能会将统计结果对外展示，但在对外使用和展示中将不包含您的任何身份识别信息。</div>
      <br />
      <div class="blod-text">我们如果将您提供的个人信息用于本政策没有载明之处，将事先征求您的同意；如果我们停止提供相应的服务，我们将不再收集您的个人信息。</div>
      <br />
    </div>
    <div>
      <div class="blod-text">三、我们对您个人信息的分享</div>
      <div>您向我们提供您的个人信息是基于对我们的信任，本公司将按照中华人民共和国法律法规规定获取、管理及使用您的个人信息。对于上述个人信息，除下列情况外，本公司不会向无关第三方披露：</div>
      <div>(1) 基于用户的同意或授权；</div>
      <div>(2) 为向您提供服务，委托履行某项义务的第三方处理您提供的个人信息；</div>
      <div>(3) 基于法律法规的要求（或为不违反法律法规）或基于需要对国家政府机构、地方政府组织或者上述单位的委托单位所开展的法定工作配合、而取得用户的同意可能对工作开展造成妨碍；</div>
      <div>(4) 为维护社会公共利益（涉及国家、国防安全问题，公共卫生、安全问题等法律规定的情况）或基于保护生命、防止人身伤害或保护财产目的需要使用，但同时又难以得到您的同意</div>
      <div>(5) 因不可抗力导致个人信息公开的，但该种情况下，我们会尽最大努力补救并尽可能及时通知您；</div>
      <div>(6) 在不违反相关法律法规的前提下，基于业务相关事件（如兼并等），为继续进行业务活动需要。</div>
      <br />
    </div>
    <div>
      <div class="blod-text">四、我们对未成年人的信息保护</div>
      <div class="blod-text">我们非常重视对未成年人信息的保护，且本小程序及我们提供的服务仅面向成年人，我们不向18周岁以下的未成年人提供服务，不处理任何未成年人信息，也不会将未成年人的信息用于广告或营销。</div>
      <br />
    </div>
    <div>
      <div class="blod-text">五、您对您个人信息的管理</div>
      <div class="blod-text">您可以随时管理您提供给我们的个人信息。您可以在任何时候通过下述方式查看、修改或删除您的个人信息，具体方式如下：</div>
      <div class="blod-text">如您需要修改“我的服务单”内具体的期望服务时间、期望联系电话、联系人、服务地址（也即设备所在地址），您可以点击小程序主页右下方的“个人中心”—点击“我的服务单” —点击“进行中”—点击具体需要修改的服务单，或是点击小程序首页的“进度查询”—点击“进行中”—点击具体需要修改的服务单进行修改。</div>
      <div class="blod-text-i">*需要向您特别提示的是，如果订单处于派单状态，这意味着我们已经在将您的订单派发给具体服务人员，无法及时同步您修改后的信息。因此，如您需要修改的，请在订单尚处于“受理”状态时操作，其他状态下将无法修改，以避免发生我们未能与您取得联系、在期望时间提供服务、提供期望服务等情况。</div>
      <div class="blod-text">如您需要再次访问本政策， 您可以点击小程序主页右下方的“个人中心”—“关于大金服务” —点击“个人信息保护政策”进行查看。</div>
      <div class="blod-text">如您需要撤回对本政策的同意，您可以点击小程序主页右下角的“个人中心”—“关于大金服务”— 点击“大金服务小程序个人信息保护政策”最下方的“撤销同意”，“撤销同意”成功后会退出登录。</div>
      <div class="blod-text">如您需要注销登录或者要删除您的个人信息，您可以点击小程序主页右下角的“个人中心”—“关于大金服务”— 点击“注销账号”，进行操作。</div>
      <br />
    </div>
    <div>
      <div class="blod-text">六、我们对本政策的修改</div>
      <div>
        <span>为了给您带来更好地服务体验，我们将持续努力改进我们的服务、技术与本小程序等，当服务、技术、业务流程及本小程序发生变更时，我们可能会根据需要修改个人信息保护政策，任何修改都会将对您个人信息的保护以及您的满意度置于首位。</span>
        <span class="blod-text">本政策修订后，您再次进入本小程序时，我们会再次征得您确认及同意。</span>
      </div>
      <br />
    </div>
    <div>
      <div class="blod-text">七、我们对您个人信息的保护措施</div>
      <div>我们将严格保护您的个人信息安全，采取包括但不限于以下措施：</div>
      <div>(1) 我们将使用合理安全技术和程序等措施来保护您的个人信息不被未经授权的访问、篡改、披露或破坏；</div>
      <div>(2) 在发生威胁您的个人信息安全的事件时，我们将及时跟您取得联系，告知您基本情况，并采取相应措施，以最大限度保护您的个人信息安全；</div>
      <div>(3) 其他客观可行的、可以保护您个人信息的有效措施。</div>
      <br />
    </div>
    <div>
      <div class="blod-text">八、联系我们</div>
      <div>我们非常重视您的意见。如果您有以下问题，请联系大金空调中国微信在线客服或400-820-1081售后坐席并作充分描述，我们将在15个工作日内予以答复：</div>
      <div>(1) 对本小程序的个人信息保护政策有任何的问题；</div>
      <div>(2) 您认为我们处理和使用个人信息的过程中有任何侵犯您合法权益的事件发生；</div>
      <div>(3) 您不再继续使用我们的服务，并主动注销了您的登录，要求我们删除相关信息；</div>
      <div>(4) 其他您认为需要及时与我们联系的问题。</div>
      <br />
    </div>
    <div>
      <div class="blod-text">九、其他</div>
      <div>如果本政策与《大金服务小程序隐私保护指引》存在不一致处，以本政策为准。</div>
      <br />
      <div>本小程序的运营者为：大金空调技术（中国）有限公司</div>
      <div>注册地址：上海市静安区南京西路1468号305室</div>
      <div>个人信息保护负责人联系方式：400-820-1081</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.agreement-content {
  font-size: 14px;
  color: #333333;
  line-height: 1.6;

  > div {
    font-weight: 400;
  }
}

.blod-text {
  font-weight: bold;
  font-family: "Microsoft YaHei", "微软雅黑", "PingFang SC", "Helvetica Neue", sans-serif;
  color: #000000;
}

.blod-text-i {
  color: #000000;
  font-weight: bold;
  font-family: "Microsoft YaHei", "微软雅黑", "PingFang SC", "Helvetica Neue", sans-serif;
  text-decoration: underline;
  text-underline-offset: 4rpx;
  text-decoration-thickness: 2rpx;
}
</style>
